import { render, staticRenderFns } from "./AsideBar.vue?vue&type=template&id=db079faa"
import script from "./AsideBar.vue?vue&type=script&lang=js"
export * from "./AsideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports